import { render, staticRenderFns } from "./chooseSingleResource.vue?vue&type=template&id=4fe74c35&scoped=true"
import script from "./chooseSingleResource.vue?vue&type=script&lang=js"
export * from "./chooseSingleResource.vue?vue&type=script&lang=js"
import style0 from "./chooseSingleResource.vue?vue&type=style&index=0&id=4fe74c35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe74c35",
  null
  
)

export default component.exports